import { getFilteredPricesByCountryCodeAndCurrency } from "./formatProduct"
import getNetMSRPByShopCountryCode from "./attributes/getNetMSRPByShopCountryCode"
import getDeliveryTimeWorkDaysByShopCountryCode from "./attributes/getDeliveryTimeWorkDaysByShopCountryCode"

import { ConfigurationGroupProduct, RawMSRPPriceAttribute } from "@secureo/common/typings/Product"
import { RawProduct } from "../graphql/queries/fetchProduct"
import { CurrencyCode } from "@secureo/common/typings/Forex"

const formatConfigurationGroupProduct = (
	configurationGroupProduct: RawProduct,
	currencyCode: CurrencyCode,
) => {
	const {
		id,
		masterData: {
			current: {
				name,
				description = null,
				masterVariant: { sku, prices, images = [], attributesRaw = [] },
			},
		},
	} = configurationGroupProduct

	const image = images?.[0]?.url

	const pricesByCountryCode = getFilteredPricesByCountryCodeAndCurrency(prices, currencyCode)

	const msrpPriceAttribute = attributesRaw.find(({ name }) => name === "msrpPrice")
	const netMsrpPriceByCountryCode = getNetMSRPByShopCountryCode(
		msrpPriceAttribute as RawMSRPPriceAttribute,
	)
	const deliveryTimeWorkDaysAttribute = attributesRaw.find(
		({ name }) => name === "deliveryTimeWorkdays",
	)
	const deliveryTimeWorkDaysByShopCountryCode = getDeliveryTimeWorkDaysByShopCountryCode(
		deliveryTimeWorkDaysAttribute as any,
	)

	const formattedConfigurationGroupProduct: ConfigurationGroupProduct = {
		productId: id,
		sku,
		name,
		image,
		description,
		pricesByCountryCode,
		netMsrpPriceByCountryCode,
		deliveryTimeWorkDaysByShopCountryCode,
	}

	return formattedConfigurationGroupProduct
}

export default formatConfigurationGroupProduct
